(() => {
  const initialized = new WeakSet();

  const init = (root = document) => {
    root.querySelectorAll('.hm-header').forEach((header) => {
      if (initialized.has(header)) return;
      initialized.add(header);

      const desktopMenus = [...header.querySelectorAll('.hm-nav-dropdown')];
      const mobileGroups = [...header.querySelectorAll('.hm-mobile-menu__group')];

      desktopMenus.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (!menu.open) return;
          desktopMenus.forEach((other) => {
            if (other !== menu) other.removeAttribute('open');
          });
        });
      });

      mobileGroups.forEach((group) => {
        group.addEventListener('toggle', () => {
          if (!group.open) return;
          mobileGroups.forEach((other) => {
            if (other !== group) other.removeAttribute('open');
          });
        });
      });

      header.addEventListener('click', (event) => {
        if (event.target.closest('a')) {
          desktopMenus.forEach((menu) => menu.removeAttribute('open'));
        }
      });

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) {
          desktopMenus.forEach((menu) => menu.removeAttribute('open'));
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        desktopMenus.forEach((menu) => menu.removeAttribute('open'));
        const mobileMenu = header.querySelector('.hm-mobile-menu');
        if (mobileMenu) mobileMenu.removeAttribute('open');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
